/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_PhotographyInputs */

const en_val_photography = /** @type {(inputs: Val_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photography`)
};

const es_val_photography = /** @type {(inputs: Val_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografía`)
};

const fr_val_photography = /** @type {(inputs: Val_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photographie`)
};

const de_val_photography = /** @type {(inputs: Val_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografie`)
};

const ja_val_photography = /** @type {(inputs: Val_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`写真`)
};

const zh_val_photography = /** @type {(inputs: Val_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摄影`)
};

const ar_val_photography = /** @type {(inputs: Val_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصوير فوتوغرافي`)
};

const id_val_photography = /** @type {(inputs: Val_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografi`)
};

const it_val_photography = /** @type {(inputs: Val_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografia`)
};

const ru_val_photography = /** @type {(inputs: Val_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фотография`)
};

const pt_val_photography = /** @type {(inputs: Val_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografia`)
};

const ko_val_photography = /** @type {(inputs: Val_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사진`)
};

/**
* | output |
* | --- |
* | "Photography" |
*
* @param {Val_PhotographyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_photography = /** @type {((inputs?: Val_PhotographyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_PhotographyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_photography(inputs)
	if (locale === "es") return es_val_photography(inputs)
	if (locale === "fr") return fr_val_photography(inputs)
	if (locale === "de") return de_val_photography(inputs)
	if (locale === "ja") return ja_val_photography(inputs)
	if (locale === "zh") return zh_val_photography(inputs)
	if (locale === "ar") return ar_val_photography(inputs)
	if (locale === "id") return id_val_photography(inputs)
	if (locale === "it") return it_val_photography(inputs)
	if (locale === "ru") return ru_val_photography(inputs)
	if (locale === "pt") return pt_val_photography(inputs)
	return ko_val_photography(inputs)
});